import React from "react";

const Textarea = ({
  name,
  label,
  placeholder,
  value,
  error,
  required = false,
  rows = 4,
  onChange,
  className = "",
  ...props
}) => {
  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <div className={`form-field form-group  ${className}`}>
      <label className="form-field__label form-label" htmlFor={name}>
        {label}
        {required && (
          <span className="form-field__required text-danger ms-1">*</span>
        )}
      </label>

      <textarea
        name={name}
        id={name}
        placeholder={placeholder}
        value={value}
        rows={rows}
        className={`form-field__textarea form-control ${
          error ? "form-field__textarea--error is-invalid" : ""
        }`}
        onChange={handleChange}
        required={required}
        {...props}
      />

      {error && (
        <div className="form-field__error invalid-feedback d-block">
          {error}
        </div>
      )}
    </div>
  );
};

export default Textarea;
